<template>
  <label
    data-testid="checkout-date-tile"
    class="relative bg-white rounded-md shadow-sm flex items-center justify-center w-24 flex-none h-20 text-gray-brand-900 focus:outline-none border transition-all"
    :class="[
      { 'ring-2 ring-gray-brand-700 bg-gray-brand-200 text-brand-800': checked },
      isLoadingSlot ? 'cursor-wait' : 'cursor-pointer hover:bg-gray-brand-100 hover:transform hover:scale-105'
    ]"
  >
    <input
      :value="id"
      type="radio"
      class="sr-only"
      :checked="checked"
      :disabled="isLoadingSlot"
      @click="option.can_select && !isLoadingSlot && clickedOption(id)"
    />
    <div
      v-if="!option.can_select"
      class="absolute rounded-full flex items-center justify-center text-xs font-semibold uppercase tracking-tighter text-gray-700 leading-3 px-1.5 py-1 text-center"
      :class="{
        'bg-red-500 text-red-800 -mt-2.5 mx-auto top-0 -rotate-1': option.closed,
        'bg-white border border-gray-brand-600 top-0 -mt-2 mx-auto rotate-12 text-center py-0.5 w-[6.5rem]':
          option.hasnt_started_yet,
        'bg-gray-brand-600 text-gray-100 -mt-2.5 mx-auto top-0 -rotate-1': option.has_ended,
        'bg-yellow-400 text-yellow-800 -mt-2.5 mx-auto top-0 -rotate-1': option.sold_out
      }"
    >
      <span v-if="option.closed">Closed</span>
      <span v-else-if="option.hasnt_started_yet">Opens {{ willOpenMonthDayAndTime }}</span>
      <span v-else-if="option.has_ended">Ordering closed</span>
      <span v-else-if="option.sold_out">Sold Out</span>
    </div>
    <div
      v-if="option.price_label && !isLoadingSlot"
      data-testid="checkout-date-tile-price"
      class="absolute bottom-0 -mb-2 mx-auto rounded-full bg-white border border-gray-brand-600 px-1.5 py-0.5 text-xxs font-semibold text-gray-brand-800 whitespace-nowrap"
    >
      {{ option.price_label }}
    </div>
    <div
      class="flex flex-col items-center justify-center p-3 min-h-[4.5rem]"
      :class="{
        'text-gray-400': !option.can_select && !isLoadingSlot,
        'text-gray-900': option.can_select && !isLoadingSlot
      }"
    >
      <template v-if="isLoadingSlot">
        <svg
          class="animate-spin h-6 w-6 text-brand-500"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" />
          <path
            class="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          />
        </svg>
      </template>
      <template v-else>
        <span class="block text-xs font-medium text-center">
          {{ fulfillmentSlotDayOfWeek }}
        </span>
        <span class="text-xl font-bold">{{ fulfillmentSlotDayOfMonth }}</span>
        <span class="block text-xs font-medium text-center">{{ fulfillmentSlotMonth }}</span>
      </template>
    </div>
  </label>
</template>

<script>
import mapRelationship from '../../utils/mapRelationship'
import { serverDayToDateObject } from '@/helpers/dates'

export default {
  name: 'InfoRowSlotDay',
  components: {},
  props: {
    option: { type: Object, required: true },
    selected: { default: undefined },
    loadingSlotId: { type: [String, Number], default: null }
  },
  data: () => ({}),
  computed: {
    isLoadingSlot() {
      return this.loadingSlotId != null && this.option?.fulfillment_slot_id == this.loadingSlotId
    },
    id() {
      return this.option.fulfillment_slot_id
    },
    fulfillmentDate() {
      return this.option.date
    },
    bottle() {
      return this.$store.getters.currentBottle
    },
    currentFulfillmentSlot() {
      return mapRelationship(this.$store.state, this.bottle.relationships?.fulfillment_slot.data)
    },
    checked() {
      return (
        // strict check with false so that it only applies in the method selection section
        // tbh all of this should be done differently, the separation of responsiblities between all the layers of components is absolutely all over the place
        this.selected !== false &&
        this.option?.date == this.currentFulfillmentSlot?.attributes?.arrives_beginning_estimate_date
      )
    },
    fulfillmentSlotDate() {
      return this.option.date
    },
    fulfillmentSlotDayOfWeek() {
      return new Intl.DateTimeFormat('en-US', {
        weekday: 'long'
      }).format(serverDayToDateObject(this.fulfillmentSlotDate))
    },
    fulfillmentSlotDayOfMonth() {
      return new Intl.DateTimeFormat('en-US', {
        day: 'numeric'
      }).format(serverDayToDateObject(this.fulfillmentSlotDate))
    },
    fulfillmentSlotMonth() {
      return new Intl.DateTimeFormat('en-US', {
        month: 'long'
      }).format(serverDayToDateObject(this.fulfillmentSlotDate))
    },
    willOpenMonthDayAndTime() {
      return new Intl.DateTimeFormat('en-US', {
        timeZone: this.merchantTZ,
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric'
      }).format(new Date(this.option.will_open_datetime))
    },
    merchantTZ() {
      return mapRelationship(this.$store.state, this.bottle.relationships.merchant.data)?.attributes.time_zone
    }
  },
  methods: {
    clickedOption(value) {
      this.$emit('clickedOption', value)
    }
  }
}
</script>
